module.exports = __webpack_public_path__ + "img/percent.304f6c04.svg";